export default "/images/vendor/flag-icon-css/flags/4x3/th.svg?d3dea0cee87c83e3a1e65baf0081b1e3";